
import { defineComponent, computed, ref } from 'vue'
import { useStore } from 'vuex'
import { IStoreType } from '@/store/types'
import { Iarchives_l, IarchivesType } from '@/store/page-file/types'

import '@/assets/font/iconfont'
export default defineComponent({
  props: {
    isShows: {
      type: Boolean
    }
  },
  setup(props, context) {
    const store = useStore<IStoreType>()
    const categoryList = computed(() => {
      return store.state.pageFileModule.category
    })
    const active = ref<string>('')
    const categoryFn = (key: string, value: Iarchives_l[]) => {
      active.value = key
      let obj: IarchivesType = {}
      obj[key] = value
      context.emit('onCategory', obj)
    }
    return {
      categoryList,
      categoryFn,
      active
    }
  }
})
